import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import { verificationMyBooking } from '../api/appointment';

function LoginPage() {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    kodeTest: '',
    nomorPeserta: ''
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));

    // clear error saat user mengetik
    if (error) setError(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);

    // ✅ FE validation
    if (!formData.kodeTest.trim()) {
      setError('Kode Peserta wajib diisi.');
      return;
    }

    if (!formData.nomorPeserta.trim()) {
      setError('Nomor Peserta wajib diisi.');
      return;
    }

    setLoading(true);

    try {
      const res = await verificationMyBooking({
        kode_peserta: formData.kodeTest,
        nomor_peserta: formData.nomorPeserta
      });

      if (res.status === true) {
        // simpan token participant
        localStorage.setItem('token_participant', res.data.token);

        // optional simpan booking_id
        // if (res.data.booking_id) {
        //   localStorage.setItem('booking_id', res.data.booking_id);
        // }

        navigate('/booking-detail');
      } else {
        // ✅ tampilkan message backend
        setError(res.msg || 'Anda belum melakukan booking konseling.');
      }
    } catch (err) {
      // ✅ handle HTTP error dari backend
      setError(
        err?.response?.data?.error ||
        err?.response?.data?.msg ||
        'Terjadi kesalahan saat verifikasi booking.'
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <Header />
      
      <div className="container mt-5 pt-5">
        <div className="content mx-auto" style={{ maxWidth: '600px' }}>
          <div className="container d-flex justify-content-center">
            <div className="login-card row g-0 shadow-lg rounded-4 overflow-hidden">
              <div className="col-md-12 login-left p-4 p-md-5">
                <h4 className="text-center login-title mb-4">
                  Cek Jadwal Konseling
                </h4>

                <div className="illustration-box mb-4 text-center">
                  <img
                    src="https://calista.ekahospital.com/auth/resources/v8578/login/eka_theme_v3/img/illustration-login.svg"
                    alt="Login Illustration"
                    className="img-fluid"
                    style={{ maxWidth: '180px' }}
                  />
                </div>

                <form id="loginForm" onSubmit={handleSubmit}>
                  <div className="mb-3">
                    <label htmlFor="kodeTest" className="form-label fw-medium">
                      Kode Peserta Anda
                    </label>
                    <input
                      type="text"
                      id="kodeTest"
                      name="kodeTest"
                      className="form-control form-control-lg"
                      placeholder="Masukkan kode peserta"
                      value={formData.kodeTest}
                      onChange={handleInputChange}
                    />
                  </div>

                  <div className="mb-3">
                    <label htmlFor="nomorPeserta" className="form-label fw-medium">
                      Nomor Peserta Anda
                    </label>
                    <input
                      type="text"
                      id="nomorPeserta"
                      name="nomorPeserta"
                      className="form-control form-control-lg"
                      placeholder="Masukkan nomor peserta"
                      value={formData.nomorPeserta}
                      onChange={handleInputChange}
                    />
                  </div>

                  {/* ✅ ERROR MESSAGE INLINE */}
                  {error && (
                    <div className="alert alert-danger mt-2">
                      {error}
                    </div>
                  )}

                  <button 
                    type="submit" 
                    className="btn btn-masuk w-100 py-3 mt-3"
                    disabled={loading}
                  >
                    {loading ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm me-2"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        Memproses...
                      </>
                    ) : 'MASUK'}
                  </button>
                </form>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LoginPage;
